export const batchPaymentMethodOptions = [
  { value: 'bank_billet', label: 'Boleto bancário' },
  { value: 'bank_transfer', label: 'Transferência bancária' },
  { value: 'credit', label: 'Cartão de crédito' },
  { value: 'debit', label: 'Cartão de débito' },
  { value: 'cash', label: 'Dinheiro' },
  { value: 'pix', label: 'Pix' }
]
